import { Component, OnInit } from '@angular/core';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-empty-ingredient',
  templateUrl: './warning-empty-ingredient.component.html',

})
export class WarningEmptyIngredientComponent implements OnInit {
 
    faWarning: any = faWarning;
  constructor() { }

  ngOnInit() {
  }

}
